/**
 * 개발 환경에서만 콘솔에 출력. 프로덕션 번들에서는 NODE_ENV === 'production'으로 제거·무보장.
 */
const isDev =
  typeof process !== 'undefined' &&
  process.env &&
  process.env.NODE_ENV === 'development';

export function devLog(...args) {
  if (isDev) console.log(...args);
}

export function devWarn(...args) {
  if (isDev) console.warn(...args);
}
